<template>
  <div class="space-y-4">
    <div v-if="isLoading" class="text-gray-500">Loading item types...</div>
    <div v-else-if="errorMessage" class="text-red-500">{{ errorMessage }}</div>
    <div v-else-if="filteredItemTypes.length === 0" class="text-gray-500">
      No item types found.
    </div>

    <div v-else class="overflow-x-auto">
      <table class="min-w-full bg-white border border-gray-200 rounded-lg">
        <thead class="bg-gray-50">
          <tr>
            <th class="px-4 py-2 text-left font-medium">Name</th>
            <th class="px-4 py-2 text-left font-medium">Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(itemType, index) in filteredItemTypes"
            :key="itemType.item_type_id || itemType.id || itemType.name || index"
            class="border-t border-gray-200"
          >
            <td class="px-4 py-2 text-sm text-gray-700">{{ itemType.name || "-" }}</td>
            <td class="px-4 py-2 text-sm text-left">
              <button
                class="bg-orange-400 text-white rounded-md font-medium px-3 py-1"
                @click="editRecord(itemType)"
              >
                Edit
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import api from "@/services/api";

export default {
  name: "ItemTypesTab",
  props: {
    searchQuery: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      itemTypes: [],
      isLoading: false,
      errorMessage: "",
    };
  },
  computed: {
    filteredItemTypes() {
      if (!this.searchQuery) return this.itemTypes;
      const q = this.searchQuery.toLowerCase();
      return this.itemTypes.filter((itemType) =>
        (itemType?.name || "").toLowerCase().includes(q)
      );
    },
  },
  methods: {
    editRecord(itemType) {
      this.$emit('edit-item-type', itemType);
    },
    async fetchItemTypes() {
      this.isLoading = true;
      this.errorMessage = "";
      try {
        const response = await api.getItemTypes();
        this.itemTypes = Array.isArray(response)
          ? response
          : response?.data || response?.item_types || [];
      } catch (error) {
        this.errorMessage = error?.message || "Failed to fetch item types.";
      } finally {
        this.isLoading = false;
      }
    },
  },
  mounted() {
    this.fetchItemTypes();
  },
};
</script>
